import { CSSObject } from 'theme-ui';

export interface FontFaceDescription extends CSSObject {
    fontFamily: string;
    src: string;
}

export function createFontFaceObjectCollection(fontFaceDescriptions: FontFaceDescription[]): CSSObject[] {
    return fontFaceDescriptions.map((fontFaceDescription: FontFaceDescription) => ({
        '@font-face': fontFaceDescription,
    }));
}
